import React from "react";
import PropTypes from "prop-types";

import { StyledPurchaseButton } from "./styles";

import { usePayPalNounProSubContext } from "frontend/context/PayPalNounProSubContext";

import { PRO_ANNUAL_DOWNLOAD, PRO_MONTHLY_DOWNLOAD } from "icons/helpers";

const CheckoutFormPurchaseButton = ({
    onClick,
    showPayPalButton,
    isProcessing,
    isDisabled,
    licenseSelection,
    children
}) => {
    const {
        PurchaseButtonMonthly,
        PurchaseButtonYearly
    } = usePayPalNounProSubContext();

    let PayPalButton = () => null;

    if (licenseSelection === PRO_ANNUAL_DOWNLOAD)
        PayPalButton = PurchaseButtonYearly;

    if (licenseSelection === PRO_MONTHLY_DOWNLOAD)
        PayPalButton = PurchaseButtonMonthly;

    return showPayPalButton ? (
        <PayPalButton disabled={isDisabled} />
    ) : (
        <StyledPurchaseButton
            isProcessing={isProcessing}
            disabled={isDisabled}
            onClick={onClick}
        >
            {children}
        </StyledPurchaseButton>
    );
};

CheckoutFormPurchaseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    showPayPalButton: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isDisabled: PropTypes.bool,
    licenseSelection: PropTypes.string.isRequired
};

export default CheckoutFormPurchaseButton;
